import { Alert, CircularProgress } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import ReactImageGallery from 'react-image-gallery';
import { config } from 'variables/config';
import 'react-image-gallery/styles/css/image-gallery.css';
import { useAuthHeader } from 'react-auth-kit';

const ImageGallery = ({ images }) => {
  const [blobItems, setBlobItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const authHeader = useAuthHeader();
  // Stable key: only changes when the actual UUIDs change, not on every render
  const imageKey = images?.map((i) => i.uuid || i.original).join(',') ?? '';

  useEffect(() => {
    if (!imageKey) {
      setBlobItems([]);
      return;
    }

    let cancelled = false;

    const fetchImages = async () => {
      setLoading(true);
      try {
        const results = await Promise.all(
          (images ?? []).map(async (item) => {
            const uuid = item.uuid || item.original;
            try {
              const response = await axios.get(
                `${config.app.api_url}/files/s3/presigned-url/${uuid}?minutes=30`,
                {
                  headers: {
                    Authorization: authHeader(),
                  },
                }
              );
              const presignedUrl = response.data?.data || response.data?.url;
              return {
                ...item,
                original: presignedUrl,
                thumbnail: presignedUrl,
              };
            } catch (error) {
              console.error(`Failed to fetch presigned URL for ${uuid}:`, error);
              return null;
            }
          })
        );
        if (!cancelled) setBlobItems(results.filter((item) => item !== null));
      } catch (error) {
        console.error('Error fetching images:', error);
        if (!cancelled) setBlobItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchImages();

    return () => {
      cancelled = true;
    };
  }, [imageKey]);

  if (loading) return <CircularProgress />;

  return blobItems.length > 0 ? (
    <ReactImageGallery items={blobItems} />
  ) : (
    <Alert severity="error">No images to display</Alert>
  );
};

export default ImageGallery;
